import { render, staticRenderFns } from "./campusDetailCen.vue?vue&type=template&id=54884481&scoped=true&"
import script from "./campusDetailCen.vue?vue&type=script&lang=js&"
export * from "./campusDetailCen.vue?vue&type=script&lang=js&"
import style1 from "./campusDetailCen.vue?vue&type=style&index=1&id=54884481&scoped=true&lang=scss&"
import style2 from "./campusDetailCen.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54884481",
  null
  
)

export default component.exports